
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PageItemProps } from ".";
import { loading, update } from "store/page";
import { AppMessage } from "components";

interface ApiPageUpdateInputProps extends PageItemProps {
}

type ApiPageUpdateOutputProps = OutputBaseProps<{ item: PageItemProps; }, ApiPageUpdateInputProps>

export const apiPageUpdate = async (data: ApiPageUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiPageUpdateOutputProps>("/api/page/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};